"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Gallery = void 0;
var React = require("react");
var react_image_gallery_1 = require("react-image-gallery");
var images = [
    {
        original: 'image/gallery/1.jpg',
        thumbnail: 'image/gallery/1.jpg',
    },
    {
        original: 'image/gallery/2.jpg',
        thumbnail: 'image/gallery/2.jpg',
    },
    {
        original: 'image/gallery/3.jpg',
        thumbnail: 'image/gallery/3.jpg',
    },
    {
        original: 'image/gallery/4.jpg',
        thumbnail: 'image/gallery/4.jpg',
    },
    {
        original: 'image/gallery/5.jpg',
        thumbnail: 'image/gallery/5.jpg',
    },
    {
        original: 'image/gallery/6.jpg',
        thumbnail: 'image/gallery/6.jpg',
    },
    {
        original: 'image/gallery/7.jpg',
        thumbnail: 'image/gallery/7.jpg',
    },
    {
        original: 'image/gallery/8.jpg',
        thumbnail: 'image/gallery/8.jpg',
    },
    {
        original: 'image/gallery/9.jpg',
        thumbnail: 'image/gallery/9.jpg',
    },
    {
        original: 'image/gallery/10.jpg',
        thumbnail: 'image/gallery/10.jpg',
    },
    {
        original: 'image/gallery/11.jpg',
        thumbnail: 'image/gallery/11.jpg',
    },
];
var Gallery = function () {
    return (React.createElement("div", { style: {
            //backgroundColor: 'black',
            backgroundImage: 'linear-gradient(rgb(0,0,0,0.8) 0%, rgb(0,0,0,0.8) 100%), url("image/gallery/1.jpg")',
            backgroundSize: 'cover',
            padding: '5em 1em 5em 1em'
        } },
        React.createElement(react_image_gallery_1.default, { items: images })));
};
exports.Gallery = Gallery;
//# sourceMappingURL=Gallery.js.map